import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { Loader } from '@googlemaps/js-api-loader';

window.GoogleMaps = {
  MarkerClusterer,
  Loader,
};
